var exports = {
  "nK": "xaee3c4fa--66b760--comments",
  "TL": "xaee3c4fa--66b760--comments__headline",
  "JN": "xaee3c4fa--66b760--comments___headline_title",
  "UG": "xaee3c4fa--66b760--comments__headline_num",
  "RD": "xaee3c4fa--66b760--comments__subscribe",
  "ap": "xaee3c4fa--66b760--login__error",
  "o5": "xaee3c4fa--66b760--comments__add-comment",
  "bI": "xaee3c4fa--66b760--comments__add-comment_input",
  "NA": "xaee3c4fa--66b760--comments__list",
  "ko": "xaee3c4fa--66b760--comments__list_wrap-comment",
  "pO": "xaee3c4fa--66b760--comments__item_photo",
  "PU": "xaee3c4fa--66b760--comments__item_info",
  "u0": "xaee3c4fa--66b760--comments__form_info",
  "GE": "xaee3c4fa--66b760--comments__form_photo",
  "G6": "xaee3c4fa--66b760--comments__form_photo-default",
  "ER": "xaee3c4fa--66b760--comments__item_name",
  "h5": "xaee3c4fa--66b760--comments__item_date",
  "Pp": "xaee3c4fa--66b760--comments__form_sender",
  "yS": "xaee3c4fa--66b760--comments__item_name-text",
  "_": "xaee3c4fa--66b760--comments__item_honest",
  "Ql": "xaee3c4fa--66b760--comments__item_best-advice",
  "n9": "xaee3c4fa--66b760--comments__form_addressed",
  "gM": "xaee3c4fa--66b760--comments__form_icon-answer",
  "sd": "xaee3c4fa--66b760--comments__item_text",
  "ZG": "xaee3c4fa--66b760--comments__item_bottom-line",
  "pB": "xaee3c4fa--66b760--comments__item_bottom-line-item",
  "Xh": "xaee3c4fa--66b760--answer__item_bottom-line",
  "eV": "xaee3c4fa--66b760--comments__item_wrap-info",
  "tB": "xaee3c4fa--66b760--comments__form_wrap-info",
  "ip": "xaee3c4fa--66b760--comments__list-answer",
  "Ax": "xaee3c4fa--66b760--comments__list-answer_item",
  "iT": "xaee3c4fa--66b760--comments__list_item-new",
  "uX": "xaee3c4fa--66b760--comments__list-answer_add",
  "p3": "xaee3c4fa--66b760--comments__list-answer_add-btn",
  "l8": "xaee3c4fa--66b760--comments__list_item",
  "vG": "xaee3c4fa--66b760--comments__form",
  "FD": "xaee3c4fa--66b760--comments__form_add-comment",
  "_s": "xaee3c4fa--66b760--comments__form_email",
  "$Y": "xaee3c4fa--66b760--comments__form_name",
  "QO": "xaee3c4fa--66b760--comments__form_publish-btn",
  "dr": "xaee3c4fa--66b760--comments__form_publish",
  "Bz": "xaee3c4fa--66b760--answer__comment-form",
  "Ev": "xaee3c4fa--66b760--comments__form_warning",
  "$L": "xaee3c4fa--66b760--comments__form_warning-close",
  "Z9": "xaee3c4fa--66b760--comments__likes-wrap-dekstop",
  "zg": "xaee3c4fa--66b760--comments__likes-wrap-mobile",
  "a5": "xaee3c4fa--66b760--comments__form_add-comment-wrap",
  "Hc": "xaee3c4fa--66b760--comments__form_email-wrap",
  "kC": "xaee3c4fa--66b760--comments__form_name-wrap",
  "If": "xaee3c4fa--66b760--comments__form_add-comment-error",
  "Hw": "xaee3c4fa--66b760--comments__form_email-error",
  "Yx": "xaee3c4fa--66b760--comments__form_name-error",
  "tT": "xaee3c4fa--66b760--comments__form_add-comment-empty",
  "r_": "xaee3c4fa--66b760--comments__form_name-empty",
  "Us": "xaee3c4fa--66b760--comments__form_email-invalid",
  "W$": "xaee3c4fa--66b760--subscribe-wrap",
  "qV": "xaee3c4fa--66b760--comments__form_add-comment-offset-mobile",
  "fx": "xaee3c4fa--66b760--comments__form_email-offset-mobile",
  "S$": "xaee3c4fa--66b760--comments__form_name-offset-mobile",
};

module.exports = exports;
